import { inspectClipboardToastStatus } from "atoms/inspect.state";
import { LinkIcon } from "cssReset/icon";
import { useSetRecoilState } from "recoil";
import { InspectShareBoxContainer } from "style/inspect";
import { getResultImageByType } from "utils/inspect.util";

interface sensitivityResult {
  id: number;
  title: string;
  imgPath: string;
  description: string;
  contents: string;
}

interface DataProps {
  id: number;
  data: sensitivityResult;
}

const InspectShareBox = ({ data, id }: DataProps) => {
  const setClipboard = useSetRecoilState(inspectClipboardToastStatus);

  const shareToKakao = () => {
    if (!data) return;

    const urlPath = `/inspect/simple/result/preview/detail/${id}`;
    Kakao.Share.sendCustom({
      templateId: 119524,
      templateArgs: {
        title: data.title,
        contents: data.contents,
        THU: `https://old.sombat.co.kr/${getResultImageByType(id)}`,
        like: 0,
        comment: 0,
        view: 0,
        url: urlPath,
      },
    });
  };

  const shareFaceBook = () => {
    if (!data) return;

    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=https://old.sombat.co.kr/backend/preview/share/inspect/${id}`;

    const appShareUrl = `https://old.sombat.co.kr/backend/preview/share/inspect/${id}`;

    const payload = {
      type: "buttonClicked", // 고정된 메시지 타입
      platform: "facebook", // 공유 플랫폼 정보
      contentType: "review", // column 또는 review
      url: appShareUrl, // 실제 공유 URL
    };

    // ✅ iOS WebView
    if (window.webkit?.messageHandlers?.buttonClicked) {
      window.webkit.messageHandlers.buttonClicked.postMessage(payload);
    }
    // ✅ Android WebView
    else if (window.ReactNativeWebView?.postMessage) {
      window.ReactNativeWebView.postMessage(JSON.stringify(payload));
    }
    // ✅ 일반 브라우저 (PC 또는 모바일 웹)
    else {
      window.open(shareUrl, "_blank");
    }
  };

  const linkCopyHandler = async () => {
    try {
      if (!data) return;
      const shareUrl = `https://old.sombat.co.kr/backend/preview/share/inspect/${id}`;

      await navigator.clipboard.writeText(shareUrl);
    } catch (err) {
      console.error("복사에 실패했어요. 다시 시도해 주세요.");
    } finally {
      setClipboard(true);
    }
  };

  return (
    <InspectShareBoxContainer>
      <div className="title">결과 공유하기</div>
      <div className="btn-box">
        <button onClick={shareToKakao}>
          <span className="icon-box">
            <img src="/assets/icon/SNS/kakaotalk/Default.png" alt="" />
          </span>
          카카오톡 공유하기
        </button>
        <button onClick={shareFaceBook}>
          <span className="icon-box">
            <img
              src="/assets/icon/SNS/Facebook/Facebook - Original.png"
              alt=""
            />
          </span>
          페이스북 공유하기
        </button>
        <button onClick={linkCopyHandler}>
          <span className="icon-box">
            <LinkIcon />
          </span>
          공유링크 복사하기
        </button>
      </div>
    </InspectShareBoxContainer>
  );
};

export default InspectShareBox;
